<template>
  <ul class="breadcrumb">
    <slot></slot>
  </ul>
</template>

<script>
  export default {
    name: 'Breadcrumb'
  }
</script>


// WEBPACK FOOTER //
// breadcrumb.vue?1ea63c6c